import Vue from "vue";
import Router from "vue-router";
// import defaultSettings from '../settings'
Vue.use(Router);

export const constantRoutes = [
    {
        path: "/",
        component: () =>
            import ("@/views/home/index"),
        name: 'home-page'
    },
    {
        path: "/accordQuery",
        component: () =>
            import ("@/views/accordQuery/index"),
        name: 'accord-query'
    },
    {
        path: "/accordDetail",
        component: () =>
            import ("@/views/accordQuery/detail"),
        name: 'accord-detail'
    },
    {
        path: "/promSuggest",
        component: () =>
            import ("@/views/promSuggest/index"),
        name: 'prom-suggest'
    },
    {
        path: "/sugSubmit",
        component: () =>
            import ("@/views/sugSubmit/index"),
        name: 'sug-submit'
    },
    {
        path: "/promDetail",
        component: () =>
            import ("@/views/promSuggest/detail"),
        name: 'prom-detail'
    },
];

export default new Router({
    mode: "hash", // 去掉url中的#
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
});